<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-66">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <i class="md-icon fas fa-male" />
                                </div>
                                <h4 class="title">Liste des techniciens</h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                                <div class="flex items-center">
                                    <div>
                                        <md-checkbox v-model="filter.isActive" class="mb-0 mt-1 mr-0">Techniciens actifs</md-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table v-model="technicians" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="#"><span>{{ item.id }}</span></md-table-cell>
                                <md-table-cell md-label="Nom"><span>{{ item.full_name }}</span></md-table-cell>
                                <md-table-cell md-label="" style="max-width: 40px;">
                                    <md-button class="md-info py-0" @click="goToRoute('Technician Details', 'idTechnician', item.id)">Voir le détail</md-button>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
				<md-card class="card-table">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="md-layout">
							<div class="md-layout-item">
								<div class="card-icon">
									<md-icon>pending_actions</md-icon>
								</div>
								<h4 class="title">Gestion des absences</h4>
							</div>
							<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
								<div class="flex items-center">
									<div>
										<md-button class="md-info md-sm md-datatable"
												   @click="goToRoute('Add Absence')">
											<md-icon class="material-icons mr-1">add</md-icon>
											<span>Ajouter une absence</span>
										</md-button>
									</div>
								</div>
							</div>
						</div>
					</md-card-header>
					<md-card-content>
						<div>
							<span class="font-bold">Filtres</span>
						</div>
						<div class="flex items-center mb-2">
							<div class="mr-4" style="min-width: 250px;">
								<div class="md-multiselect">
									<label>Technicien</label>
									<multiselect
										v-model="filter.technician"
										:options="technicians"
										:show-labels="false"
										track-by="id"
										label="full_name"
										placeholder="Technicien">
										<template slot="noOptions">La liste est vide</template>
										<template slot="noResult">Aucun élement correspondant</template>
									</multiselect>
								</div>
							</div>
							<div class="mr-6" style="min-width: 350px;">
								<div class="md-multiselect md-multiselect-multiple">
									<label>Types d'absence</label>
									<multiselect
										v-model="filter.absences"
										:multiple="true"
										:options="absenceTypes"
										:show-labels="false"
										:close-on-select="false"
										track-by="id"
										label="name"
										placeholder="Absence">
										<template slot="noOptions">La liste est vide</template>
										<template slot="noResult">Aucun élement correspondant</template>
									</multiselect>
								</div>
							</div>
							<md-button class="md-default md-dense" @click="clearFilter">Effacer les filtres</md-button>
						</div>
						<md-table
							:value="absences"
							class="paginated-table"
							table-header-color="blue"
						>
							<md-table-toolbar>
								<md-field>
									<label for="pages">Éléments à afficher</label>
									<md-select v-model="pagination.perPage" name="pages">
										<md-option
											v-for="item in pagination.perPageOptions"
											:key="item" :label="item" :value="item">
											{{ item }}
										</md-option>
									</md-select>
								</md-field>
							</md-table-toolbar>

							<md-table-row slot="md-table-row" slot-scope="{ item }">
								<md-table-cell md-label="Technicien">
									{{ item.user.full_name }}
								</md-table-cell>
								<md-table-cell md-label="Type d'absence">
									<span>{{ item.absence_type.name }}</span>
								</md-table-cell>
								<md-table-cell md-label="Motif" style="max-width: 100px;">
									<span>{{ item.comment }}</span>
								</md-table-cell>
								<md-table-cell md-label="Jour" style="max-width: 50px;">
									<span>{{ (item.day_number || item.day_number === 0) ? days[item.day_number] : '-' }}</span>
								</md-table-cell>
								<md-table-cell md-label="Début" style="max-width: 75px;">
									<span>{{ $moment(item.date_start).format('DD/MM/YYYY' + (item.absence_type_id === 7 ? ' à HH:mm' : '')) }}</span>
								</md-table-cell>
								<md-table-cell md-label="Fin" style="max-width: 75px;">
									<span>{{ item.date_end ? $moment(item.date_end).format('DD/MM/YYYY' + (item.absence_type_id === 7 ? ' à HH:mm' : '')) : '-' }}</span>
								</md-table-cell>
								<md-table-cell md-label="" style="max-width: 75px;">
									<div class="w-full flex items-center justify-end">
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-warning"
													   @click="goToRoute('Edit Absence', 'idAbsence', item.id)">
												<md-icon>edit</md-icon>
											</md-button>
											<md-tooltip md-direction="top">Modifier</md-tooltip>
										</div>
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-danger"
													   @click="deleteAbsence(item.id)">
												<i class="md-icon fa fa-trash"/>
											</md-button>
											<md-tooltip md-direction="top">Supprimer</md-tooltip>
										</div>
									</div>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</md-card-content>
					<md-card-actions md-alignment="space-between">
						<p class="card-category">
							Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
						</p>
						<pagination
							class="pagination-no-border pagination-info"
							v-model="pagination.currentPage"
							:per-page="pagination.perPage"
							:total="pagination.total"
							@input="getAbsences"
						>
						</pagination>
					</md-card-actions>
				</md-card>
            </div>
        </div>
    </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
    name: "Technicians",
	components: {
    	Pagination
	},
    data() {
        return {
            technicians: [],
			days: [],
            absences: [],
			absenceTypes: [],
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [10, 25, 50, 100],
				total: 0
			},
			filter: {
            	technician: null,
				absences: [],
                isActive: true
			},
			searchedData: [],
        }
    },
	computed: {
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.searchedData.length > 0
				? this.searchedData.length
				: this.absences.length;
		},
	},
    methods: {
		async getAbsences() {
			const response = await this.$store.dispatch('absences/getAbsences',
				{
					page: this.pagination.currentPage,
					per_page: this.pagination.perPage,
					technician_id: this.filter.technician?.id ?? null,
					absence_types: this.filter.absences.map(absence => absence.id)
				}
			)
			this.absences = response.data.data
			this.pagination.total = response.data.total
		},
        async getTechnicians() {
            const { data } = await this.$store.dispatch('users/getTechnicians', {
                isActive: this.filter.isActive
            })
            this.technicians = data
        },
		async getAbsenceTypes() {
			const { data } = await this.$store.dispatch('absences/getAbsenceTypes')
			this.absenceTypes = data
		},
		async deleteAbsence(id) {
			try {
				await this.$store.dispatch('absences/deleteAbsence', { absence_id: id })
				await this.$store.dispatch('alerts/success', 'Absence supprimée')
				await this.getAbsences()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Suppression impossible')
			}
		},
		clearFilter() {
			this.filter = {
				idTechnician: null,
				absences: []
			}
		},
		formatWeekdays() {
			let days = []
			this.$moment.weekdays(true).map(day => {
				days.push(day.charAt(0).toUpperCase() + day.slice(1))
			})
			days.pop()
			days.pop()
			this.days = days
		},
        goToRoute(route, param = null, id = null) {
            this.$router.push({ name: route, params: { [param]: id } })
        },
    },
	watch: {
		'filter.technician'() {
			this.getAbsences()
		},
		'filter.absences'() {
			this.getAbsences()
		},
        'filter.isActive'() {
		    this.getTechnicians()
        }
	},
    mounted() {
		this.getAbsences()
        this.getTechnicians()
		this.getAbsenceTypes()
		this.formatWeekdays()
    }
}
</script>

<style scoped>

</style>
